import { ErrorBoundary } from '@toss/error-boundary';
import { SubscriptionRejectedFallback } from '../../components/service/subscription/components/SubscriptionRejectedFallback';
import { SubscriptionPaymentSection } from '../../components/service/subscription/subscriptionPayment';
export const PlanCheckoutPageView = () => {
  return <ErrorBoundary renderFallback={fallbackProps => <SubscriptionRejectedFallback {...fallbackProps} />} data-sentry-element="ErrorBoundary" data-sentry-component="PlanCheckoutPageView" data-sentry-source-file="plan-checkout.tsx">
      <SubscriptionPaymentSection data-sentry-element="SubscriptionPaymentSection" data-sentry-source-file="plan-checkout.tsx" />
    </ErrorBoundary>;
};